import React from 'react';
import { FadeIn } from './FadeIn';
export function BenefitsSection() {
  return <section className="py-6 md:py-24 px-4 bg-white" data-id="element-14">
      <div className="max-w-4xl mx-auto text-center" data-id="element-15">
        <FadeIn data-id="element-16">
          <h2 className="font-display font-black text-3xl md:text-6xl text-gray-900 mb-6 md:mb-12" data-id="element-17">
            Tu vida en <span className="text-celeste" data-id="element-18">30 días</span>
          </h2>

          <img src="https://cdn.magicpatterns.com/uploads/vP6s5HwuELiTHWAZ2Njmbj/EBOOK_CHAU_VAPE_8.png" alt="CHAU VAPE - Antes y Después en 30 días" className="w-full rounded-xl mb-4 md:mb-6 shadow-lg" data-id="element-19" />

          <p className="text-lg md:text-2xl text-gray-700 font-medium max-w-2xl mx-auto" data-id="element-20">
            En 30 días, tu cuenta bancaria y tus pulmones te lo van a agradecer.
          </p>
        </FadeIn>
      </div>
    </section>;
}